import { cva } from 'class-variance-authority';

import s from './ButtonGroup.module.css';

export const buttonGroupVariants = cva(s.buttonGroup, {
  defaultVariants: {
    background: 'default',
  },
  variants: {
    background: {
      default: '',
      'gradient-accent': s['buttonGroup--background-gradient-accent'],
    },
    fullWidth: {
      true: s['buttonGroup--fullWidth'],
    },
  },
});
